import { Telework } from './telework';
import { CommonUtils, Factory } from '@infodata-group/inf-commons';

export class TeleworkFactory implements Factory<Telework[]> {
  build(o: any) {
    const teleworks = [];
    const startDate = CommonUtils.convertStrToDate(o.startDate);
    const endDate = CommonUtils.convertStrToDate(o.endDate);
    while (startDate <= endDate) {
      teleworks.push(
        new Telework(o.resourceId, CommonUtils.convertDateToString(startDate)),
      );
      startDate.setDate(startDate.getDate() + 1);
    }
    return teleworks;
  }

  getApi() {
    return 'telework';
  }
}
